'use strict';

angular.module('portal.login')
    .controller('Login', ['$scope', '$state', '$stateParams', '$rootScope', '$window', 'Utils', 'Authentication', 'PortalPermissions', 'localStorageService', 'Account', 'EnterpriseLoginCriteria', 'Enterprise', 'Saml', 'Session', function ($scope, $state, $stateParams, $rootScope, $window, Utils, Authentication, PortalPermissions, localStorageService, Account, EnterpriseLoginCriteria, Enterprise, Saml, Session) {
        $scope.loading = false;
        $scope.idpLoading = false;
        $scope.showPassword = false;
        $scope.disablePasswordLogin = false;
        $scope.idpList = [];
        $scope.surpressRedirect = $stateParams.surpressRedirect == "true" || false;
        $scope.showForceLogin = false;
        if ($stateParams.messages && $stateParams.messages.length > 0 && $stateParams.messages[0] == "You have reached the maximum number of concurrent sessions possible. Please logout from other devices and try again.") {
            $scope.showForceLogin = true;
        }

        $scope.signature = {
            isPortal: true,
            username: null,
            pass: null
        }
        $scope.forgot_link = "";

        PortalPermissions.view("portal.menus.forgotusername").then(function (access) {
            $scope.forgot_username = access;
        });
        PortalPermissions.view("portal.menus.forgotpassword").then(function (access) {
            $scope.forgot_password = access;
        });
        PortalPermissions.view("portal.menus.createaccount").then(function (access) {
            $scope.create_account = access;
        });
        $scope.goto_forgot_username = function() {
            $state.go('portal.menus.forgotusername');
        }
        $scope.goto_forgot_password = function () {
            $state.go('portal.menus.forgotpassword');
        }
        $scope.goto_create_account = function () {
            $state.go('portal.menus.createaccount');
        }

        EnterpriseLoginCriteria.getEnterpriseDisablePasswordLogin().then(function (disable) {
            $scope.disablePasswordLogin = disable;
        });

        Enterprise.listPublicEnterpriseIdentityProvider().then(function (idpList) {
            $scope.idpList = idpList;

            if (!$scope.surpressRedirect && $scope.disablePasswordLogin && $scope.idpList.length == 1) {
                Saml.idpSignIn(true, $scope.idpList[0].entityId || $scope.idpList[0].metadataUrl).then(function (ret) {
                    if (ret && ret.redirectUrl) {
                        $window.location = ret.redirectUrl;
                    }
                });
            }
        });

        $scope.idpSignIn = function (entityId) {
            $scope.idpLoading = true;
            var idp = $scope.idpList[entityId];
            var isOidc = idp.typeID.toLowerCase() === "0bea1dc0-891d-4b59-8f03-0a0648ad7aa7";
            if (isOidc) {
                // For OpenID Connect, redirect to a separate OIDC login page
                $state.go('portal.menus.oidcLogin', { identityProviderId: idp.id });
                return;
            }

            Saml.idpSignIn(true, idp.entityId || idp.metadataUrl).then(function (ret) {
                if (ret && ret.redirectUrl) {
                    $window.location = ret.redirectUrl;
                }
                else {
                    $scope.idpLoading = false;
                }
            });
        }

        // remove existing cookie and token from local storage
        Utils.DeleteSessionCookie(true);
        // expire any existing session
        Session.expireSession(true);
        localStorageService.remove('portalAuthorizationData');
        $rootScope.userAccount = null;
        
        $scope.login = function () {
            $scope.loading = true;
            Authentication.login($scope.signature).then(function(response) {
                if (response != null) {
                    Account.get({ portal: true }).then(function (account) {
                        $rootScope.userAccount = account;
                        $rootScope.loadingUserAccount = false;
                    });
                    if (response.user_id !== undefined && response.user_id.length) {
                        if (response.redirect_url.indexOf('portal.') == 0) {
                            $state.go(response.redirect_url);
                        } else {
                            $window.location = response.redirect_url;
                        }
                    } else {
                        if (response.redirect_url) {
                            $window.location = response.redirect_url;
                        }
                        else {
                            //We're staying on the same page, but we need to "reload" to get any error messages loaded in
                            var params = $rootScope.$state.current.params;
                            params.messages = [response.error_description || "Invalid Username or Password"];
                            $rootScope.$state.transitionTo($rootScope.$state.current, params, {
                                reload: true,
                                inherit: false,
                                notify: true
                            });
                        }
                        $scope.loading = false;
                    }
                }
            });
        }

        $scope.createAccount = function () {
            $scope.loading = true;
            $state.go('portal.menus.createaccount');
        }
    }])
;